import { createSlice } from '@reduxjs/toolkit';
import { SystemAlertState } from './types';
import { getSystemAlertData } from './async';
import { getColumnsFromLocalStorage } from 'modules/inbound/shared/utils/getColumnsFromLocalStorage';
import { SYSTEM_ALARMS_COLUMNS } from 'modules/inbound/entriesST12/domain/SystemAlarmsColumns';

export const GREEN = 'green700';

export const initialState: SystemAlertState = {
  workshopId: 'T12',
  systemAlertsData: [],
  systemAlertDataRequestStatus: '',
  columns: SYSTEM_ALARMS_COLUMNS,
  savedColumns: [],
  selectedColumn: {
    key: '',
    isAscending: false
  },
  selectedTruck: ''
};
const SYSTEM_ALARMS_COLUMNS_VIEW_STATE_KEY = 'EntriesST12ColumnsView';
const systemAlertDateSlice = createSlice({
  name: 'systemAlertDateSlice',
  initialState,
  reducers: {
    updateSelectedColumn: (state, action) => {
      state.selectedColumn = action.payload;
    },
    updateSelectedTruck: (state, action) => {
      state.selectedTruck = action.payload;
    },
    saveColumnsView: (state, action) => {
      localStorage.setItem(
        `${action.payload}-${SYSTEM_ALARMS_COLUMNS_VIEW_STATE_KEY}`,
        JSON.stringify(state.savedColumns)
      );
    },
    loadColumnsView: (state, action) => {
      state.savedColumns = getColumnsFromLocalStorage({
        username: action.payload,
        localStorageKey: SYSTEM_ALARMS_COLUMNS_VIEW_STATE_KEY,
        defaultColumns: [...state.columns]
      });
    },
    updateVisibleColumns: (state, action) => {
      state.savedColumns = state.savedColumns.map((item) =>
        item.key === action.payload.key
          ? { ...item, isVisibleCheck: !action.payload.isVisibleCheck }
          : item
      );
    },
    updateColumnsOrder: (state, action) => {
      state.savedColumns = action.payload;
    }
  },
  extraReducers: (builder) => {
    // SystemAlert
    builder.addCase(getSystemAlertData.fulfilled, (state, action) => {
      state.systemAlertsData = action.payload || [];
      state.systemAlertDataRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getSystemAlertData.pending, (state, action) => {
      state.systemAlertDataRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getSystemAlertData.rejected, (state, action) => {
      state.systemAlertDataRequestStatus = action.meta.requestStatus;
    });
  }
});

// selectors
export const getSystemAlerts = (state) =>
  state.systemAlertDateSliceState.systemAlertData;

export const getSystemAlertRequestStatusIsPending = (state) =>
  state.systemAlertDateSliceState.systemAlertDataRequestStatus === 'pending';
export const getSystemAlertRequestStatusHasError = (state) =>
  state.systemAlertDateSliceState.systemAlertDataRequestStatus === 'rejected';
export const getSystemAlertRequestStatusIsSucessfull = (state) =>
  state.systemAlertDateSliceState.systemAlertDataRequestStatus === 'fulfilled';

export const getWorkshopId = (state) =>
  state.systemAlertDateSliceState.workshopId;

export const getSystemAlertsValues = (state: any) => {
  const systemAlertState: SystemAlertState = state.systemAlertDateSliceState;

  return systemAlertState.systemAlertsData;
};

export const getColumns = (state) => {
  return state.systemAlertDateSliceState.savedColumns;
};
export const getSelectedColumn = (state) =>
  state.systemAlertDateSliceState.selectedColumn;

export const getSelectedTruck = (state) =>
  state.systemAlertDateSliceState.selectedTruck;

export const {
  updateSelectedColumn,
  saveColumnsView,
  loadColumnsView,
  updateVisibleColumns,
  updateColumnsOrder,
  updateSelectedTruck
} = systemAlertDateSlice.actions;

export default systemAlertDateSlice.reducer;
